import React from 'react';
import type { FieldFactoryProps, TextFieldProps as ExtraProps } from '../types';
import BaseTextField from './BaseTextField';
import omit from 'lodash/omit';

type FFProps = FieldFactoryProps<string, HTMLInputElement> & ExtraProps<HTMLInputElement>;

/**
 * Displays a field as an <input type="text"> element.
 *
 * Supports debounce. See the `debounce` property.
 */
const InputTextField = (props: FFProps) => <BaseTextField<HTMLInputElement> {...props} factory={factory} />;

const factory = ({ className, elementRef, ...props }: FFProps) => {
  const allowedProps = omit(props, [
    'Renderer',
    'error',
    'label',
    'onValueReset',
    'onValueSubmit',
    'onInputChange',
    'onValueChange',
  ]);
  return <input type="text" className={`form-control ${className}`} ref={elementRef} {...allowedProps} />;
};

export default InputTextField;
